import axios from "axios";

const dyrectApi = process.env.REACT_APP_DYRECT_API_URL;

// Track invitation sent
export const trackInvitation = async (inviterUserId, platform, inviteLink) => {
  try {
    const response = await axios.post(`${dyrectApi}invitations`, {
      inviterUserId,
      platform,
      inviteLink,
      timestamp: new Date().toISOString()
    });
    return response.data;
  } catch (error) {
    console.error("Error tracking invitation:", error);
    throw error;
  }
};

// Get user's invitation stats
export const getInvitationStats = async (userId) => {
  try {
    const response = await axios.get(`${dyrectApi}invitations/stats?userId=${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching invitation stats:", error);
    throw error;
  }
};

// Handle referral signup
export const handleReferralSignup = async (referrerUserId, newUserId) => {
  try {
    const response = await axios.post(`${dyrectApi}referrals`, {
      referrerUserId,
      newUserId,
      timestamp: new Date().toISOString()
    });
    return response.data;
  } catch (error) {
    console.error("Error handling referral signup:", error);
    throw error;
  }
};